import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TQrCode } from '@/types'
import { getAccountId, getQrServiceEndpoint } from '@/utils'
import { useAccountSettingsStore } from '@/store/accountSettings'

export const useQrCodeStore = defineStore('Filters Store', () => {
  const qrCodeLoading = ref(false)
  const qrCodeContent = ref<TQrCode[]>([])
  const accountSettings = useAccountSettingsStore()

  const generateQrCode = async (vinList: string[]) => {
    qrCodeLoading.value = true
    const qrCodeUrl = getQrServiceEndpoint()
    const requestUrl = new URL(qrCodeUrl, window.location.origin)

    const juid = String(
      accountSettings.accountId || getAccountId() || '',
    ).trim()
    const product = 'scan2sell'
    if (juid) requestUrl.searchParams.set('juid', juid)
    if (product) requestUrl.searchParams.set('product', product)

    const data = ref<any[]>([])
    const site = accountSettings?.getWebsite()
    vinList.forEach((vin: string) => {
      data.value.push({
        VIN: vin,
        URL: formatSite(site) + `/vehicle/${vin}?qr=true`,
      })
    })
    const response = await fetch(requestUrl.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data.value),
    })

    qrCodeContent.value = await response.json()
    qrCodeLoading.value = false
  }

  const formatSite = (site: string) => {
    // if site does not have https:// add it, if it has do nothing
    if (!site.startsWith('https://')) {
      return 'https://' + site
    }

    return site
  }

  return {
    //state
    qrCodeLoading,
    qrCodeContent,
    // actions
    generateQrCode,
  }
})
